<h5 mat-dialog-title i18n>Select Print Options</h5>
<div mat-dialog-content>
  <p i18n>Select options for printing the work order.</p>
  <form #printOptionsForm="ngForm" (ngSubmit)="this.data.printingFromCalendar ? printMultipleWorkOrders(printOptionsForm) :printWorkOrder()" appValidateDates>
    <div  *ngIf="data.printingFromCalendar" class="form-inline">
      <div class="form-group col-sm-6">
        <label for="startDate" class="pr-2">Start Date</label>
        <select name="startDate" id="startDate"
                required 
                class="form-control select-bidit"                
                (change)="dateChanged(printOptionsForm)"
                [(ngModel)]="selectedStartDate"
                #startDate="ngModel">
          <option selected="" [ngValue]="" i18n></option>
          <option *ngFor="let date of dateList" [ngValue]="date">{{date}}</option>
        </select>
        <small *ngIf="startDate.touched && startDate.invalid"
               class="alert alert-danger" i18n>
          Start Date is required
        </small>
      </div>
      <div class="form-group col-sm-6">
        <label for="endDate" class="pr-2">End Date</label>
        <select name="endDate" id="endDate"
                required                
                class="form-control select-bidit"
                (change)="dateChanged(printOptionsForm)"
                [(ngModel)]="selectedEndDate"
                #endDate="ngModel">
          <option selected="" [ngValue]="" i18n></option>
          <option *ngFor="let date of dateList" [ngValue]="date">{{date}}</option>
        </select>
        <small *ngIf="endDate.touched && endDate.invalid" class="alert alert-danger" i18n>
          End Date is required
        </small>
      </div>
      <div class="row">
        <small *ngIf="(startDate.touched || endDate.touched ) && printOptionsForm?.errors?.datesInvalid" class="alert alert-danger" i18n>
          Start Date cannot be greater than End Date
        </small>
      </div>

    </div>
    <div class="form-group">
      <mat-checkbox id="showPricing" name="showPricing" class="col-form-label" [(ngModel)]="showPricing" i18n>Show Line Item Labor Cost</mat-checkbox>
    </div>
    <div class="form-group">
      <select name="locale" class="form-control select-bidit" [(ngModel)]="locale">
        <option value="en">English</option>
        <option value="es">Español</option>
      </select>
    </div>
    <app-dealer-document-selection *ngIf="this.showDocuments || !documentsLoaded" (selectionUpdated)="documentSelectionUpdated($event)" (documentsLoaded)="loadDocuments($event)"></app-dealer-document-selection>

    <div class="form-group float-right">
      <button *ngIf="showPrintAttachments" mat-button type="button" (click)="showDealerDocuments()" class="btn btn-outline-primary mr-1" i18n>Attach Documents</button>

      <button type="submit" mat-button class="btn btn-bidit-action mr-1" i18n>Print</button>
      <button type="button" mat-button (click)="onNoClick()" class="btn btn-bidit-cancel" i18n>Cancel</button>
    </div>
    <app-spinner [isRunning]="isRequesting"></app-spinner>
  </form>
</div>
